import React, { FC, useState } from "react";
import { Layout, Menu } from 'antd';
import { withRouter, RouteComponentProps } from 'react-router'

import useAuth from './auth/use-auth';


const { Header } = Layout;

const HeaderContent: FC<RouteComponentProps | any> = (props) => {
    const {userHasValidToken,logout} = useAuth()
    const path = ((props.location.pathname) as string).toLowerCase();
    let pathMatch =  ((path.indexOf('loggedout') >= 0 || path.indexOf('login') >= 0) ? '1' : '2');
    
    
    const menuItemSelected = async (e: any) => {
        pathMatch = e.key;
        switch (e.key) {
            case '1':
                if (userHasValidToken()) {
                    logout();
                    props.history.push(`/loggedOut`);
                } else {
                    props.history.push(`/login`)
                }
                break;
            // case '2':
            //     props.history.push(`/qualificationA`)
            //     break;

        }
    }


    return (
        <Header style={{ position: 'fixed', zIndex: 1, width: '100%' }}>
            
            <Menu 
                onClick={(e) => menuItemSelected(e)} 
                theme="dark" 
                mode="horizontal" 
                selectedKeys={[pathMatch]}
                defaultSelectedKeys={[pathMatch]}
            >
                <Menu.Item key="1">{userHasValidToken() ? 'Logout' : 'Login'}</Menu.Item>
                {/*userHasValidToken() && (
                    <Menu.Item key="2">Qualification Form</Menu.Item>
                )*/}
            </Menu>
        </Header>
    )
}




export default withRouter(HeaderContent);